module.exports = __webpack_public_path__ + "img/pr-3.932cf68d.png";